// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"f834c7ea","297":"c1c22afa","643":"8abe04c3","959":"773e61e3"}[chunkId] + ".chunk.js";
};